import React, { Component } from "react";
import { connect } from "react-redux";

import { Translate } from "react-redux-i18n";

export class QuestionNumber extends Component {
    render() {
        return (
            <span className="question-number">
                <Translate value="question" curr={this.props.current_question} total={this.props.total_question} />
            </span>
        );
    }
}

const mapStateToProps = state => ({
    current_question: state.assessment.current_question_number,
    total_question: state.assessment.total_question,
});

export default connect(mapStateToProps)(QuestionNumber);
